module.exports = __webpack_public_path__ + "cffc3888295f3de3e5b7bb770c3ae41b.woff2";